module.exports = __webpack_public_path__ + "dc34771ac8f66734433d328db4de7e18.png";